// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.oqooPROlCY7eADrFs6c_{grid-template-rows:48px 1fr;height:100%;display:grid;overflow:hidden}.PKGvf51mazUwMBo8cONV{border-bottom:1px solid var(--border-neutral-default);align-items:center;padding:12px 8px 12px 20px;display:flex}.V54ZHugsnsIZ1KAZEFLe{width:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `oqooPROlCY7eADrFs6c_`,
	"header": `PKGvf51mazUwMBo8cONV`,
	"content": `V54ZHugsnsIZ1KAZEFLe`
};
export default ___CSS_LOADER_EXPORT___;
